import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-sub-header',
    standalone: true,
    templateUrl: './sub-header.component.html',
    styleUrls: ['./sub-header.component.scss']
})
export class SubHeaderComponent {

    @Input()
    title: string;
}
